import { Styles } from 'shared/types';

export const ButtonGroup: Styles = {
  ml: '50%',
  transform: 'translateX(-75%)',
  position: 'absolute',
};
